import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { SummaryInfo } from '../vo/summary-info.model';
import { KYMW1200Component } from '../kymw1200.component';

// レスポンス構造
export type GetCycleSummaryResponse = {
  OrderCode: string;
  CatalogId: string;
  Budget: number;
  Plan: number;
  Result: number;
  PrevResult: number;
}[];

/**
 * サイクル設定予実情報取得サービス
 * @export GetCycleSummaryService
 * @class GetCycleSummaryService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleSummaryService extends PlessJsonResponderSub<GetCycleSummaryResponse> {
  model: KYMW1200Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleSummaryService
   */
  private getBody(): PlessRequest {
    const param = {
      MediumType: this.model.searchedMediumType,
      BuyerCodes: this.model.getRequestBuyerCodes(),
      CoopCode: this.model.coopCode,
      StartOrderCode: this.model.searchedOrderCodeFrom,
      EndOrderCode: this.model.searchedOrderCodeTo,
      SupplierCode: this.model.isSupplier ? this.model.userSupplierCode : null,
      PastCycle: this.model.pastCycle,
    };
    if (!param.SupplierCode) delete param.SupplierCode;

    return new PlessRequest({
      parameter: param,
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCycleSummaryService
   */
  execute(
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.model.summaryList = [];
    this.succeed = s;
    this.fail = f;
    this.send('getCycleSummary', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleSummaryService
   */
  success(data: GetCycleSummaryResponse) {
    this.model.summaryList = data.map(_ => new SummaryInfo(_));
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
